import { render } from "./BedroomCount.vue?vue&type=template&id=83666ce8&scoped=true"
import script from "./BedroomCount.vue?vue&type=script&lang=js"
export * from "./BedroomCount.vue?vue&type=script&lang=js"

import "./BedroomCount.vue?vue&type=style&index=0&id=83666ce8&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83666ce8"]])

export default __exports__